

import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import useAxios from 'library/axios'; 
import { useEffect, useState } from 'react';
import { IStockMovement, IStockMovementSearch } from "../models/StockMovement";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';

import { currentUserSessionAtom } from 'library/store';
import { isNumber, toNumber } from 'lodash';
import { useQuery } from 'react-query';
import { ISchoolYear } from 'features/setup/models/SchoolYear';


const _ = () => {

    const axios = useAxios(); 

    //const {schoolYears} = useRecoilValue(currentUserSessionAtom);    

    const createStockMovement = async (stockMovement: IStockMovement)  =>       
        await (await axios.post('/api/configuration/stockMovement/create', stockMovement)).data;       
        
    const updateStockMovement = async (stockMovement: IStockMovement)  =>       
        await (await axios.post('/api/configuration/stockMovement/update', stockMovement)).data; 
    
    const getStockMovement = async (id  : number )  => {
      const {data} = (await axios.get(`/api/configuration/stockMovement/get-stockMovement/${id}`));
      return await data;
    }
   
    const getStockMovements = async (criteria: IStockMovementSearch, pagination?: IPagination) : Promise<IStockMovement[]> => {

      const {reference, description } = criteria;

      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {data} = (await axios.get(`/api/configuration/stockMovement/get-stockMovements?reference=${reference}&description=${description}` +
          `&pageSize=${pageSize}&pageNumber=${pageNumber}`));
          
      return await data;
    }

      
    return {    
      createStockMovement,
      updateStockMovement,
      getStockMovement,
      getStockMovements,
      
    } 
}

export default _;

export interface IFilterStockMovementOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [number[], React.Dispatch<React.SetStateAction<number[]>>],
  stateFiltered?: [IStockMovement[], React.Dispatch<React.SetStateAction<IStockMovement[]>>],
}

const defaultFilterStockMovementOption: IFilterStockMovementOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterStockMovement = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IStockMovement) => void,
                    filterOption?: IFilterStockMovementOption  ) => {

  const { getStockMovements } = _();

  const { t, i18n } = useTranslation();   

  const { applicationSetup } = useRecoilValue(currentUserSessionAtom);

  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterStockMovementOption;

  //const {data: schoolYears} = useQuery<ISchoolYear[]>( ['SchoolYears'], () => getSchoolYears( {year: 0, name: ''}) );

  const [headStockMovementCells, setHeadStockMovementCells]  = useState<HeadCell<IStockMovement>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', width: 5 },    
    {id:'reference', label : t('Reference'),  display: true, type: 'string', width: 20 },
    {id:'description', label : t('Description'),  display: true, type: 'string', width: 20},

    {id:'issueDate', label : t('Date'),  display: true, type: 'date', width: 10},
    {id:'status', label : t('Status'),  display: true, type: 'string', width: 15},


  ]); 
  
  const [filterElements,setFilterElements] = useState<ITextFilterElement[]>([         
       
    {name: 'reference', text: t('Reference'), value: ''},
    {name: 'description', text: t('Description'), value: ''},
           
  ]);
  
  const [filteredDeliveries, ] = useState<IStockMovement[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<IStockMovement[]> => {
    
    const reference = filterElements.find( elt => elt.name === 'reference')?.value || '';
    const description = filterElements.find( elt => elt.name === 'description')?.value || '';
    
    const arr = await getStockMovements( {reference, description}, pagination );
   
    return arr;
  }

  const objKey: keyof IStockMovement = 'id';

  return {
    title: `${t('StockMovement')}(s)`, headCells: headStockMovementCells, objKey,
    filterElements, rows: filteredDeliveries, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}
